<template>
<div>

    <wewHeader></wewHeader>

    <wewSteps v-bind:stepActive="2"></wewSteps>


    <section class="step-2 pad-t-90 pad-b-80" style="background: #EFEFEF;margin-top:-100px;">
        
        <div class="container">
            <h1 class="text-center">PLEASE UPLOAD IMAGES OF YOUR CAR</h1>
            <div class="w-grid trim gutters-4x">
                <div v-for="(upload,index) in uploads" v-bind:key="index" class="w-1 w-sm-1-2 w-lg-1-4 text-center">
                    <h2 class="pad-t-60 pad-b-20">{{ upload.title }}</h2>
                    <input 
                        :name="index"
                        style="display:none;" 
                        type="file"
                        @change="onFileSelected" 
                        ref="fileInput">
                    
                    <div class="upload-area bg-cover" :style="upload.complete ? [ { backgroundImage: 'url('+upload.uploadImageSrc+')'} ] : [{ backgroundImage: 'none'}]">
                        <div v-if="!upload.complete">
                            <button v-if="!upload.complete && !upload.uploading" class="m4c-upload-btn" @click="$refs.fileInput[index].click()">
                                <div style="">Upload<br>+</div>
                            </button>
                            <div v-if="upload.uploading">
                                <div class="lds-ellipsis">
                                    <div></div><div></div><div></div><div></div>
                                </div>
                                <div>
                                    <button type="button" @click="upload.canceled=true">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="min-height: 30px;">
                        <button v-show="upload.complete" type="button" @click="revokeUpload(index)">Remove</button>
                    </div>
                </div>
            </div>
            
            <div class="text-center pad-t-60 pad-b-20">
                <p class="upload-msg" v-if="!allImagesUploaded" v-html="uploadErrorMsg"></p>
                <button :disabled="!allImagesUploaded" type="submit" class="m4c-btn color-white marg-r-10 marg-t-10" @click="goToNextStep('step3')"><span class="v-top">NEXT STEP</span></button>
            </div>
        </div>

    </section>
    
    <wewFooterWhite></wewFooterWhite>
</div>
</template>

<script>
import wewHeader from '@/components/Header'
import wewSteps from '@/components/Steps'
import * as firebase from 'firebase'
import wewFooterWhite from '@/components/wew-footer-white'
import ImageCompressor from 'image-compressor.js'

var urlCreator = window.URL || window.webkitURL;

export default {
    name: 'step2',
    components: {
        wewHeader,
        wewSteps,
        wewFooterWhite
    },
    data() {
        return {
            uploads: [
                { title: 'FRONT', uploading: false, uploadImageSrc: '', complete: false, canceled: false },
                { title: 'DRIVER SIDE', uploading: false, uploadImageSrc: '', complete: false, canceled: false },
                { title: 'REAR', uploading: false, uploadImageSrc: '', complete: false, canceled: false },
                { title: 'PASSENGER SIDE', uploading: false, uploadImageSrc: '', complete: false, canceled: false }
            ],
            uploadProgress: 0
        }
    },
    computed: {
        submission() {
          return this.$store.getters.submission
        },
        allImagesUploaded() {
            let allComplete = true
            this.uploads.forEach(el=> {
                if(!el.complete) {
                    allComplete = false
                }
            })
            return allComplete
        },
        uploadErrorMsg() {
            let incompletes = []
            this.uploads.forEach(el=> {
                if(!el.complete) {
                    incompletes.push(el.title)
                }
            })
            let msg = 'You must upload an image for <span class="color-blue">' + incompletes.join(', ') + '</span> above before continuing.'
            let n = msg.lastIndexOf(',')
            if(n==-1)
                return msg
            let begin = msg.slice(0,n)
            let end = msg.slice(n+1,msg.length)
            return begin + ' &' + end
            
        }

    },
    methods: {
        onFileSelected(event) {
            //console.log(event)
            //bytes size INT: event.target.files[0].size
            //file type eg. "image/jpeg": event.target.files[0].type
            //filename: event.target.files[0].name
            //Prototype of event.target.files[0] is Blob
            
            const file = event.target.files[0]
            if(!file) {
                return;
            }
            const size = file.size
            if(size>12000000) {
                alert('The selected file is too large for uploading, please select a smaller file')
                return
            }
            //const type = file.type
            //if(type!=='') {
            //    return
            //}
            let flip = true
            if(size>5000000) { //image greater than 5mb so don't use flip to save crashing
                flip = false   
            }
            const index = event.srcElement.name
            this.uploads[index].uploading = true

            let that = this
            new ImageCompressor(file, {
                checkOrientation: flip,
                quality: .9,
                maxWidth: 600,
                maxHeight: 900,
                width: 600,
                success(compressedFile) {  // the resized Blob object
                    //Browser generated url for image so it can be used as a src
                    const imageURL = urlCreator.createObjectURL(compressedFile);
                    
                    //Set the thumbnail to the compressed image url (not the downloadURL)
                    that.uploads[index].uploadImageSrc = imageURL

                    //Now upload the file
                    that.onUpload(index, compressedFile, imageURL)
                },
                error(err) {
                    console.log(err.message)
                    this.uploads[index].uploading = false
                }
            })
            
            
        },
        onUpload(index, file, imageURL){
            
            const fd = file
            var storage = firebase.storage()
            var storageRef = storage.ref()
            var uploadTask = storageRef.child('images/' + fd.name).put(fd)

            var that = this
            // Register three observers:
            // 1. 'state_changed' observer, called any time the state changes
            // 2. Error observer, called on failure
            // 3. Completion observer, called on successful completion
            uploadTask.on('state_changed', function(snapshot){
               
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                that.uploadProgress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                //console.log('Upload is ' + that.uploadProgress + '% done');

                //Check if the upload was canceled from the user action
                if(that.uploads[index].canceled) {
                    if(that.uploadProgress!==100) {
                        //commit harikari on upload task
                        snapshot.task.cancel()
                        that.revokeUpload(index)
                    }
                }

                switch (snapshot.state) {
                    case firebase.storage.TaskState.CANCELED:
                        console.log('Upload was canceled')
                    break;
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        console.log('Upload is paused')
                    break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        console.log('Upload is ' + that.uploadProgress + '% done')
                        console.log('Upload is running')
                    break;
                }
            }, function(error) {
                // Handle unsuccessful uploads
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                    case 'storage/unauthorised':
                        console.log('Error: Upload is unauthorised');
                    break;
                    case 'storage/canceled':
                        console.log('Error: Upload was canceled');
                    break;
                }
                that.revokeUpload(index)

            }, function() {
                console.log('upload completed')
                // Handle successful uploads on complete
                that.uploads[index].complete = 2
                that.uploads[index].uploading = false
                that.uploadProgress = 0
                
                // Get the download URL: https://firebasestorage.googleapis.com/...
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    
                    //Clear the compressed image URL we created earlier
                    urlCreator.revokeObjectURL(imageURL)

                    //that.$store.dispatch('setSubmissionUploadLink', downloadURL)
                    that.$store.dispatch('storeCustomerImageUploads', {title: that.uploads[index].title, url: downloadURL})
                })
            })
            /*
            axios.post(
                'https://', fd, { 
                    onUploadProgress: uploadEvent => {
                        console.log('Progress: ' + Math.round(uploadEvent.loaded / uploadEvent.total * 100) + '%')
                    } //firebase cloud function endpoint
            })
            .then(res => {
                console.log(res)
            })*/
        },
        revokeUpload(index) {
            // reset the temp uploads obj and the file input too!
            this.$refs.fileInput[index].value = null
            this.uploads[index].canceled = false //needs to be false to allow another try
            this.uploads[index].uploading = false
            this.uploads[index].complete = false
            this.uploads[index].uploadImageSrc = ''
            this.$store.dispatch('revokeCustomerImageUpload', this.uploads[index].title)
        },
        goToNextStep(route) {
            this.$router.push(route)
        }
    }
}
</script>

<style>
.step-2 h1{
    font-size: 38px;
}

.upload-msg{
    font-size: 21px;
}
.upload-area {
    background-color: #CCCCCC!important;
    border-radius: 30px;
    height: 240px;
    width: 240px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
}

.m4c-upload-btn {
    font-size: 24px;
    line-height: 24px;
    font-weight: 400;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius:200px;
    width:160px;
    height:160px;
    background-color:#E5E5E5;
}

.m4c-upload-btn:hover {
    transform: scale(1.1) scaleZ(1.0);
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #666666;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}




</style>
